"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DynamicDialogConfig = /** @class */ (function () {
    function DynamicDialogConfig() {
    }
    return DynamicDialogConfig;
}());
exports.DynamicDialogConfig = DynamicDialogConfig;
//# sourceMappingURL=dynamicdialog-config.js.map